import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
export var REGIONS_BY_COUNTRY_PROP = PropTypes.shape({
  isLoading: PropTypes.bool,
  content: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    label: EBPropTypes.translation.isRequired
  })))
});
export var COUNTRIES_PROP = PropTypes.shape({
  isLoading: PropTypes.bool,
  content: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    label: EBPropTypes.translation.isRequired,
    'zip_required': PropTypes.bool
  }))
});